(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.ucwsTrioCTAClickable = {
    attach: function (context, settings) {

      // Make the complete card section clickable
      $('.block.trio-cta.card .rounded-box').on('click', function () {
        if (($('a', this).attr('href')) != undefined){
          window.location.href = $('a', this).attr('href');
        }
      });

      // When the CTA is focused, add a focus-like outline to the entire card.
      const trioCTAs = $('.block.trio-cta.card a.btn-cta');
      trioCTAs.on('focus', function () {
        $(this).closest('.cursor-cta').addClass('focus-on');
      });
      trioCTAs.on('blur', function () {
        $(this).closest('.cursor-cta').removeClass('focus-on');
      });
    }
  };
})(jQuery, Drupal);
